/* eslint-disable import/prefer-default-export */

export const SELECTED_VENUE_OWNERSHIP_CHANGED = 'SELECTED_VENUE_OWNERSHIP_CHANGED';
export const FOLDER_CHANGED = 'FOLDER_CHANGED';
export const SEARCH_TERM_CHANGED = 'SEARCH_TERM_CHANGED';
